// extracted by mini-css-extract-plugin
module.exports = {"root":"FormLabel_root"};